import React from 'react';
import family from "@/assets/images/family.svg";
import finance from "@/assets/images/finance.svg";
import extracurricular from "@/assets/images/extracurricular.svg";
import work from "@/assets/images/work.svg";
import heath from "@/assets/images/health.svg";
import home from "@/assets/images/home.svg";


const FeedItem = (item) => {

    const chooseIcon = (category) => {
        if (category === 'Family & Household'){
            return family;
        }else if (category === 'Finance'){
            return finance;
        }else if (category === 'Work'){
            return work
        }else if (category === 'Extracurriculars'){
            return extracurricular
        }else if (category === 'Health'){
            return heath
        }
    };

    return (
        <div className="reminder-item">
            <div className="d-flex align-items-center">
                <div className="reminder-icon-wrap flex-shrink-0 me-3">
                    {chooseIcon(item.feedItem.category) && (
                        <img
                            src={chooseIcon(item.feedItem.category)}
                            style={{ maxWidth: '18px', height: 'auto' }}
                        />
                    )}
                </div>
                <p className="mb-0 reminder-text">
                    {item.feedItem.info}
                </p>
            </div>
        </div>
    );

};

export default FeedItem;